/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useTheme } from '../../../providers/theme';
// import { useSMSignInUser } from '../machines/signInUser';

import toast from 'react-hot-toast';
import { VApplication } from '@/application';
import { SignInPageService } from '../services';
import { useSMSignInPageGetContent } from '../machines/pageContent';
import {
  PageContainer,
  GoBackLink,
  Heading,
  Logo,
  FormComp,
  SubmitButton,
  OTPComp,
  SubHeading,
  ImageIcon,
  TopAuthorsWidget,
} from '../components';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { useSMGetSignInType } from '../machines/getSignInType';
// import { useSMSendOTP } from '../machines/sendOTP';
// import { fillTemplate } from '@vlinder-web/utils-react';
import { useSMGetEmailDetails } from '../machines/getEmailDetails';
import { useNavigate } from 'react-router-dom';

const MODULE_NAME = 'signInPage';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.SignInPageService') as SignInPageService;
};

export const ContainerComm = (props: any) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [email, setEmail] = useState();
  // const { signInUserMachine, signInUserSend, signInUserState } =
  //   useSMSignInUser({});
  const { getSignInTypeState, getSignInTypeSend } = useSMGetSignInType({});
  // const { sendOTPState, sendOTPSend } = useSMSendOTP({});
  const { signInPageGetContentState } = useSMSignInPageGetContent({});
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const { getEmailDetailsState, getEmailDetailsSend } = useSMGetEmailDetails(
    {}
  );

  const renderSubmitButton = () => {
    return <SubmitButton />;
  };

  const onIdentifierSubmit = (data: any) => {
    console.log('signIn data', data);
    if (data?.email) {
      getEmailDetailsSend('START', {
        email: data?.email,
      });
    }
    //setEmail(data?.email);

    // signInUserSend('START', {
    //   payload: {
    //     email: data?.email,
    //   },
    // });
  };

  const onLoginSubmit = (email: string, data: any) => {
    // signInUserSend('START', {
    //   payload: {
    //     email: data.email,
    //     password: data.password,
    //   },
    // });
  };

  const onOTPSubmit = (data: any) => {
    navigate('/profile/my-profile');
    // signInUserSend('VERIFY_OTP', {
    //   payload: {
    //     email: email,
    //     otp: data.otp,
    //   },
    // });
  };

  const _handleResendClick = () => {
    // sendOTPSend('START', {
    //   payload: {
    //     email: email,
    //   },
    // });
  };

  const _onSignIn = (email: string, password: string, rememberMe: boolean) => {
    // signInUserSend('START', {
    //   payload: {
    //     email: email,
    //     password: password,
    //     rememberMe: rememberMe,
    //   },
    // });
  };

  const onRoleSelect = (token: string, role: any) => {
    // signInUserSend('GET_ACCESS_TOKEN', {
    //   payload: {
    //     jwtToken: token,
    //     role: role?.uuid,
    //   },
    // });
  };

  const _getSuccessNotification = () => {
    return null;
  };
  const _getErrorNotification = () => {
    return null;
  };

  const _getPageContent = () => {
    // if (signInUserState?.matches('SIGN_IN_USER_SUCCESS')) {
    //   window.open(`/product/fhp`, '_self');
    // }
    // if (
    //   signInPageGetContentState?.matches('GET_PAGE_CONTENT') ||
    //   signInUserState?.matches('VERIFY_OTP') ||
    //   signInUserState?.matches('SIGN_IN_USER') ||
    //   signInUserState?.matches('SIGN_IN_TOKEN') ||
    //   signInUserState?.matches('ACCESS_TOKEN')
    // ) {
    //   return (
    //     <StateOSD
    //       {...(staticPageContentConfig?.loading?.GetPageLoading || {})}
    //     />
    //   );
    // }
    // if (
    //   signInUserState?.matches('SUBMIT_OTP') ||
    //   signInUserState?.matches('SUBMIT_OTP_FAILED')
    // ) {
    //   let phoneNumber = signInUserState?.event?.data?.value?.smsSent
    //     ? signInUserState?.event?.data?.value?.primaryContactNo
    //     : '';
    //   return (
    //     <Col md={4} xs={11}>
    //       <Logo logoURL={staticPageContentConfig?.header?.otp?.logo} />
    //       <GoBackLink />
    //       <Heading title={staticPageContentConfig?.header?.otp?.title} />
    //       <ImageIcon
    //         imageIconURL={staticPageContentConfig?.header?.otp?.iconURL}
    //         height={100}
    //       />
    //       <SubHeading
    //         subHeadingText={fillTemplate(
    //           staticPageContentConfig?.header?.otp?.subHeadingText,
    //           { email: email, phoneNumber: phoneNumber }
    //         )}
    //       />
    //       <OTPComp
    //         renderSubmitButton={renderSubmitButton}
    //         onFormSubmit={onOTPSubmit}
    //         onResendClick={_handleResendClick}
    //       />
    //     </Col>
    //   );
    // }

    if (getEmailDetailsState?.matches('GET_EMAIL_DETAILS')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.GetPageLoading || {})}
        />
      );
    }

    // if (signInPageGetContentState?.matches('RENDER_PAGE')) {
    console.log('getEmailDetailsState', getEmailDetailsState);
    if (
      getEmailDetailsState?.matches('GET_EMAIL_DETAILS_SUCCESS') &&
      getEmailDetailsState?.event?.data?.value
    ) {
      return (
        <Col md={4} xs={11}>
          <Logo logoURL={staticPageContentConfig?.header?.otp?.logo} />
          <GoBackLink />
          <Heading title={staticPageContentConfig?.header?.otp?.title} />
          <ImageIcon
            imageIconURL={staticPageContentConfig?.header?.otp?.iconURL}
            height={100}
          />
          <SubHeading
          // subHeadingText={fillTemplate(
          //   staticPageContentConfig?.header?.otp?.subHeadingText,
          //   { email: email, phoneNumber: phoneNumber }
          // )}
          />
          <OTPComp
            renderSubmitButton={renderSubmitButton}
            onFormSubmit={onOTPSubmit}
            onResendClick={_handleResendClick}
          />
        </Col>
      );
    } else {
      return (
        <Col xs={12} md={12}>
          <Logo logoURL={staticPageContentConfig?.header?.identifier?.logo} />
          <GoBackLink />
          <Heading title={staticPageContentConfig?.header?.identifier?.title} />
          <FormComp
            renderSubmitButton={renderSubmitButton}
            authType={'OTP'}
            onFormSubmit={onIdentifierSubmit}
          />
        </Col>
      );
    }
    // }

    if (getSignInTypeState?.matches('GET_SIGN_IN_TYPE_FAILURE')) {
      toast.error(getSignInTypeState?.event?.data?.value);
    }
  };
  return (
    <PageContainer>
      {_getSuccessNotification()}
      {_getErrorNotification()}
      {_getPageContent()}
    </PageContainer>
  );
};
